export const VERSION = 18
export const PERSISTENT_CART_KEY = 'cart'
export const PERSISTENT_CLEAR_CART_KEY = 'clearCartRequest'
